import * as React from 'react'
import {Box} from "@mui/material";
import {formatPercentage} from "@ui-seeker/utils";


export default function percentageColumn(key, label, decimals=0) {
	return {
		name: key, label: label,
		options: {
			setCellHeaderProps: () => ({ sx: {
				whiteSpace: 'pre-wrap',
			}}),
			customBodyRowRenderLite: value => <Box sx={{ textAlign: 'center' }}>
				{formatPercentage(value, { decimals })}
			</Box>
		}
	}
}